<template>
  <div class="tool-stopwatch">
    <!-- 广告位 -->
    <ad-top></ad-top>
    <!-- 简介 -->
    <el-row type="flex" justify="center">
      <el-col :md="20">
        <div class="intro-detail">
          {{ $t('tools.stopwatch.introduction') }}
          <el-link type="primary" href="https://g-lab.xyz/2022/tools-introduction-stopwatch/" target="_blank">Learn more!</el-link>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <div class="display-time">
          <span>
            <template><span v-show="hour != 0"><span v-show="hour<10">0</span>{{ hour }}:</span></template>
            <template><span v-show="minute<10">0</span>{{ minute }}:</template>
            <template><span v-show="second<10">0</span>{{ second }}.</template>
            <template><span class="display-millisecond"><span v-show="millisecond<10">0</span>{{ millisecond }}</span></template>
          </span>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <div class="btns">
          <el-button-group>
            <el-button type="primary" icon="el-icon-edit-outline"  @click="openEditTimeDialog" v-if="!editTimeBtnSmallVisiable">{{ $t('tools.stopwatch.editTime') }}</el-button>
            <el-button type="primary" icon="el-icon-refresh"  @click="reset">{{ $t('tools.stopwatch.reset') }}</el-button>
            <el-button type="primary" icon="el-icon-circle-plus-outline" @click="record('rec')">{{ $t('tools.stopwatch.record') }}</el-button>
            <el-button type="primary" icon="el-icon-video-play" v-show="!isRunning" @click="start">{{ $t('tools.stopwatch.start') }}</el-button>
            <el-button type="primary" icon="el-icon-video-pause" v-show="isRunning" @click="stop">{{ $t('tools.stopwatch.stop') }}</el-button>
          </el-button-group>
          <p>
            <el-button type="primary" icon="el-icon-edit-outline"  @click="openEditTimeDialog" v-if="editTimeBtnSmallVisiable" class="edit-time-btn-small">{{ $t('tools.stopwatch.editTime') }}</el-button>
          </p>
        </div>
      </el-col>        
    </el-row>
    <transition name="el-fade-in-linear">
      <el-row v-show="tableRowNumber > 0">
        <el-col :md="{span: 8, offset: 1}" :xs="24">
          <div class="record-table-div">
            <el-card class="box-card record-table-card" shadow="hover">
              <table class="record-table">
                <tr>
                  <th>{{ $t('tools.stopwatch.gap') }}</th>
                  <th class="record-table-col">{{ $t('tools.stopwatch.gapTime') }}</th>
                  <th class="record-table-col">{{ $t('tools.stopwatch.totalTime') }}</th>
                </tr>
                <tr v-for="data in recordData" :key="data.index" @mouseover="showDeleteIcon(data.index)" @mouseleave="deleteIconIndex = 0">
                  <td class="record-table-col" align="center">
                    #{{ data.name }}
                  </td>
                  <td class="record-table-col data-zone" align="center">
                    {{ data.gapTime }}
                  </td>
                  <td class="record-table-col data-zone" align="center">
                    {{ data.totalTime }}
                  </td>
                  <!-- <td align="center">
                    <div class="delete-icon" @click="deleteRecordData(data.index)">
                      <i class="el-icon-delete" v-show="deleteIconIndex == data.index"></i>
                    </div>
                  </td> -->
                </tr>
              </table>
            </el-card>
          </div>
        </el-col>
        <el-col :md="{span: 13, offset: 1}" :xs="24">
          <div class="record-chart">
            <el-card class="box-card" shadow="hover">
              <v-chart class="chart" :option="chartOption" autoresize />
            </el-card>
          </div>
        </el-col>
      </el-row>
     </transition>
    <!-- 广告位 -->
    <ad-bottom></ad-bottom>
    <!-- 设置起始时间弹出框 -->
    <el-dialog :title="$t('tools.stopwatch.editTime')" :visible.sync="editTime" :width="dialogWidth">
      <el-form :label-width="dialogLabelWidth">
        <el-form-item :label="$t('tools.stopwatch.hour')">
          <el-input-number v-model="edit_time_hour" controls-position="right" :min="0" :step="1"></el-input-number>
        </el-form-item>
        <el-form-item :label="$t('tools.stopwatch.minute')">
          <el-input-number v-model="edit_time_minute" controls-position="right" :min="0" :max="59" :step="1"></el-input-number>
        </el-form-item>
        <el-form-item :label="$t('tools.stopwatch.second')">
          <el-input-number v-model="edit_time_second" controls-position="right" :min="0" :max="59" :step="1"></el-input-number>
        </el-form-item>
        <el-form-item :label="$t('tools.stopwatch.millisecond')">
          <el-input-number v-model="edit_time_millisecond" controls-position="right" :min="0" :max="59" :step="1"></el-input-number>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editTime = false">{{ $t('tools.stopwatch.cancel') }}</el-button>
        <el-button type="primary" @click="handleEditTimeClose">{{ $t('tools.stopwatch.confirm') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import adTop from '../../components/ad/ad-top'
import adBottom from '../../components/ad/ad-bottom'
import 'element-ui/lib/theme-chalk/base.css';
import * as echarts from 'echarts/core';
import { GridComponent } from 'echarts/components';
import { LineChart } from 'echarts/charts';
import { UniversalTransition } from 'echarts/features';
import { CanvasRenderer } from 'echarts/renderers';
import { TooltipComponent } from 'echarts/components';
import VChart from 'vue-echarts';
import localStroage from '../../utils/localStroage';

echarts.use([GridComponent, LineChart, CanvasRenderer, UniversalTransition, TooltipComponent]);

const STOPWATCH_SAVE = 'stopwatch_save';

export default {
  name: "stopwatch",
  data() {
    return {
      isRunning: false,
      startTime: null,
      editTime: false,
      timePrecision: 30,
      timer: Object,
      hour: 0,
      minute: 0,
      second: 0,
      millisecond: 0,
      stopTime: 0,
      tableRowNumber: 0,
      deleteIconIndex: 0,
      setValue: 0,
      recordData: [],
      gapData: [],
      chartOption:{
        tooltip:{
          show: true,
          trigger: 'axis',
          axisPointer: {
            type: 'line'
          }
        },
        xAxis: {
          type: 'category',
          data: []
        },
        yAxis: {
          type: 'value',
          axisLabel:{
            formatter: this.parseTime
          }
        },
        series: [
          {
            data: [],
            type: 'line',
            tooltip: {
              valueFormatter: this.parseTime
            }
          }
        ]
      },
      dialogWidth: "30%",
      dialogLabelWidth: "50px",
      edit_time_hour: 0,
      edit_time_minute: 0,
      edit_time_second: 0,
      edit_time_millisecond: 0,
      editTimeBtnSmallVisiable: false
    }
  },
  components: {
    adTop,
    adBottom,
    VChart
  },
  methods: {
    start() {
      this.isRunning = true;
      this.startTime = Date.now() - this.setValue;
      this.timer = window.setTimeout(this.tickTock, this.timePrecision);
    },
    tickTock() {
      var currentTime = Date.now();
      if (this.startTime != null) {
        let runTime = currentTime - this.startTime + this.stopTime;
        this.displayTime(runTime);
      }
      this.timer = window.setTimeout(this.tickTock, this.timePrecision);
    },
    stop() {
      window.clearTimeout(this.timer);
      this.stopTime = this.hour * 3600000 + this.minute * 60000 + this.second * 1000 + this.millisecond * 10;
      this.record(this.stopTime);
      this.isRunning = false;
      localStroage.set(STOPWATCH_SAVE, this.stopTime);
      // 去除setValue，避免重复计算
      this.setValue = 0;
    },
    reset() {
      window.clearTimeout(this.timer);
      this.isRunning = false;
      this.stopTime = 0;
      this.hour = 0;
      this.minute = 0;
      this.second = 0;
      this.millisecond = 0;
      this.recordData = [];
      this.gapData = [];
      this.tableRowNumber = 0;
      this.chartOption.xAxis.data = [];
      this.chartOption.series[0].data = [];
      this.setValue = 0;
      localStroage.remove(STOPWATCH_SAVE);
    },
    record(timeData) {
      if (!this.isRunning) {
        return
      }

      let recordTime = Date.now();      
      
      if (this.startTime != null) {
        let runTime = 0;
        if (timeData != 'rec') {
          runTime= timeData;
        } else {
          runTime = recordTime - this.startTime + this.stopTime;
        }
        let recordTimeStr = this.parseTime(runTime);
        this.tableRowNumber++;
        // 去除毫秒后一位精度
        runTime = Math.floor(runTime / 10) * 10;
        let recordDataItem = {'index': this.tableRowNumber, 'name': this.tableRowNumber, 'totalTime': recordTimeStr, 'runTime': runTime};
        if(timeData == 'rec') {
          recordDataItem.type = 'rec';
        } else {
          recordDataItem.type = 'stop';
          recordDataItem.name = recordDataItem.name + '[' + this.$i18n.t('tools.stopwatch.pause') + ']';
        }
        
        // 计算间隔
        let lastRunTime = 0;
        if (this.tableRowNumber > 1) {
          lastRunTime = this.recordData[this.tableRowNumber - 2].runTime;
        }
        let gapTime = runTime - lastRunTime;
        let gapTimeStr = this.parseTime(gapTime);
        recordDataItem.gapTime = gapTimeStr;

        this.recordData.push(recordDataItem);
        
        // 计算图表
        let chartXData = '#' + this.$i18n.t('tools.stopwatch.gap') + this.tableRowNumber
        if(timeData != 'rec') {
          chartXData += '[' + this.$i18n.t('tools.stopwatch.pause') + ']';
        } 
        this.chartOption.xAxis.data.push(chartXData);
        this.chartOption.series[0].data.push(gapTime);
      }

    },
    parseTime(timeData){
        let parseStr = '';
        if (timeData >= 3600000) {
            let hour = Math.floor(timeData / 3600000);
            timeData = timeData % 3600000;
            if (hour < 10) {
              parseStr += '0'
            }
            parseStr += hour + ':'
        }
        
        let minute = Math.floor(timeData / 60000);
        timeData = timeData % 60000;
        if(minute < 10) {
          parseStr += '0';
        }
        parseStr += minute + ':';
     
        let second = Math.floor(timeData / 1000);
        if(second < 10) {
          parseStr += '0';
        }
        parseStr += second + '.';

        let millisecond = Math.floor((timeData % 1000) / 10);
        if(millisecond < 10) {
          parseStr += '0';
        }
        parseStr += millisecond;
        return parseStr;
    },
    displayTime(runTime) {
      if (runTime >= 3600000) {
          this.hour = Math.floor(runTime / 3600000);
          runTime = runTime % 3600000;
      }
      
      this.minute = Math.floor(runTime / 60000);
      runTime = runTime % 60000;
      
      this.second = Math.floor(runTime / 1000);
      this.millisecond = Math.floor((runTime % 1000) / 10);

    },
    showDeleteIcon(index) {
      this.deleteIconIndex = index;
    },
    openEditTimeDialog() {

      // 国际化为英语时，调整表单label宽度
      const locale = localStorage.lang;
      if (locale === "en") {
        this.dialogLabelWidth = "100px";
      } else {
        this.dialogLabelWidth = "50px";
      }
      
      this.editTime = true;
    },
    handleEditTimeClose() {

      this.reset();
      this.editTime = false;

      const editTimeValue = this.edit_time_hour * 3600000 + this.edit_time_minute * 60000 + this.edit_time_second * 1000 + this.edit_time_millisecond * 10;
      if (editTimeValue != 0) {
        this.setValue = editTimeValue;
        this.initTime();
        localStroage.set(STOPWATCH_SAVE, this.setValue);        
      }
      
      this.edit_time_hour = 0;
      this.edit_time_minute = 0;
      this.edit_time_second = 0;
      this.edit_time_millisecond = 0;
    },
    initTime() {
      this.tableRowNumber = 1;
      let recordTimeStr = this.parseTime(this.setValue);
      let name = this.tableRowNumber + '[' + this.$i18n.t('tools.stopwatch.setInit') + ']';
      this.recordData[0] = {'index': this.tableRowNumber, 'name': name, 'totalTime': recordTimeStr, 'gapTime': recordTimeStr, 'runTime': this.setValue, 'type': 'setInit'};
      this.displayTime(this.setValue);

      // 计算图表
      let chartXData = '#' + this.$i18n.t('tools.stopwatch.gap') + this.tableRowNumber + '[' + this.$i18n.t('tools.stopwatch.setInit') + ']'
      this.chartOption.xAxis.data.push(chartXData);
      this.chartOption.series[0].data.push(this.setValue);
    }
    /* deleteRecordData(index) {

      this.tableRowNumber--;

      if(index == this.recordData.length) {
        this.recordData.pop();
        return;
      }

      let frontRunTime = 0;
      let behandRecordData  = this.recordData[index];
      if(index != 1) {
        frontRunTime = this.recordData[index - 2];
      }

      
      let gapTime = behandRecordData.runTime - frontRunTime;
      let gapTimeStr = this.parseTime(gapTime);
      behandRecordData.gapTime = gapTimeStr;

      this.recordData.splice(index - 1, 2, behandRecordData);

      this.recordData.forEach((item, index) => {
        item.index = index + 1;
      })
    } */
  },
  mounted() {
    this.$nextTick(() => {
      // 获取屏幕宽度
      const windowWidth = document.documentElement.clientWidth;
      if (windowWidth <= 992) {
        // 小屏调整对话框宽度
        this.dialogWidth = "80%";
      }
      if (windowWidth <= 435) {
        // 小屏调整起始时间按钮位置
        this.editTimeBtnSmallVisiable = true;
      }

      // 读取locaStroage存储的数据
      const saveValue = localStroage.get(STOPWATCH_SAVE);
      if (saveValue != "") {
        this.setValue = saveValue; 
        this.initTime();
      }

      document.addEventListener('keydown', (e) => {
        if(e.key === ' '){
          // 解除空格触发页面滚动
          if(e.preventDefault){
              e.preventDefault();
          }
          if(!this.isRunning) {
            this.start();
          } else {
            this.stop();
          }
        } else if(e.key === 's' || e.key === 'S' ) {
          this.record('rec');
        } else if(e.key === 'r' || e.key === 'R' ) {
          this.reset();
        }
      })
    })
  }
};
</script>

<style scoped>
@font-face {
  font-family: "clockicons";
  src: url('../../assets/fonts/clockicons.woff2');
}
.display-time, .btns {
  text-align:center;
}
.display-time {
 font-size: 10rem;  
}
.display-millisecond {
  font-size: 5rem; 
}
@media screen and (max-width: 992px) {
  .display-time {
  font-size: 4rem;  
  }
  .display-millisecond {
    font-size: 2rem; 
  }
}
.display-time, .data-zone {
  font-family: 'clockicons';
  color: #555;
}
.record-table-div, .btns, .record-chart {
  margin-top: 20px;
}
.record-table-card {
  overflow-y: auto;
  height: 43vh;
}
.chart {
  height: 38vh;
}
.record-table{
  margin: 0px auto;
  /* 设置行间距 */
  border-collapse:separate; 
  border-spacing:10px;
}
.record-table-name-col {
  padding-left: 20px;
}
.record-table-col {
  width: 100px;
}
.delete-icon {
  width: 30px;
  cursor: pointer;
}
.edit-time-btn-small {
  margin-top: 20px;
}
</style>